export default function GaleriaPage() {
  const images = [
    'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&q=80',
    'https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=600&q=80',
    'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&q=80',
    'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=600&q=80',
    'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=600&q=80',
    'https://images.unsplash.com/photo-1591088398332-8596b4524afe?w=600&q=80',
    'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=600&q=80',
    'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=600&q=80',
    'https://images.unsplash.com/photo-1445019980597-93fa8acb246c?w=600&q=80'
  ];

  return (
    <div data-testid="galeria-page" style={{ background: '#FAFAF8' }}>

      {/* Hero */}
      <section style={{ background: '#050505', padding: 'clamp(6rem,12vw,10rem) clamp(2rem,8vw,8rem) clamp(3rem,6vw,5rem)', textAlign: 'center' }} data-testid="galeria-hero">
        <p style={{ fontFamily: "'Jost',sans-serif", fontSize: '0.7rem', letterSpacing: '0.35em', textTransform: 'uppercase', color: '#B8892A', marginBottom: '1rem' }}>Maison Dorée</p>
        <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 'clamp(3rem,6vw,5rem)', fontWeight: 300, color: '#FAFAF8' }}>La Galerie</h1>
      </section>

      {/* Grid */}
      <section style={{ padding: 'clamp(4rem,8vw,6rem) clamp(2rem,8vw,8rem)' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '2px' }}>
          {images.map((src, i) => (
            <div key={i} style={{ overflow: 'hidden', cursor: 'pointer' }}
              onMouseEnter={e => e.currentTarget.querySelector('img').style.transform = 'scale(1.05)'}
              onMouseLeave={e => e.currentTarget.querySelector('img').style.transform = 'scale(1)'}
              data-testid={`gallery-img-${i}`}>
              <img src={src} alt={`Galerie ${i + 1}`} style={{ width: '100%', height: '320px', objectFit: 'cover', display: 'block', transition: 'transform 0.8s cubic-bezier(0.25,0.46,0.45,0.94)' }} />
            </div>
          ))}
        </div>
      </section>

    </div>
  );
}
